<ion-header>
  <ion-toolbar mode="md">
    <ion-buttons slot="end">
      <ion-button color="dark" fill="clear" (click)="closeModal()">
        <ion-icon src="assets/ionicons/close.svg"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title size="small">
      <ion-text>{{ "account-settings.change-photo" | translate }}</ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <app-photo-cropper
          [showCurrentPreview]="true"
          [showInlineSelector]="false"
        ></app-photo-cropper>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-grid class="ion-text-center">
    <ion-button
      [disabled]="
        photoCropper?.onSaveDisable ||
        (photoCropper?.showCropper && !photoCropper?.croppedImage)
      "
      (click)="onPrimaryAction()"
    >
      <ng-container *ngIf="photoCropper?.showCropper; else selectPhotoAction">
        {{ "account-settings.crop-image" | translate }}
      </ng-container>
      <ng-template #selectPhotoAction>
        {{
          (photoCropper?.isBrowserPlatform
            ? "account-settings.upload-photo"
            : "account-settings.take-or-choose-photo"
          ) | translate
        }}
      </ng-template>
    </ion-button>
  </ion-grid>
</ion-footer>
